import React from "react";
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const ROWS = [
  {
    name: "Aditi Rao",
    email: "aditi@company.com",
    result: "success",
    rowClass: "stp-row-1",
  },
  {
    name: "—",
    email: "temp183@mailinator.com",
    result: "spam",
    rowClass: "stp-row-2",
  },
  {
    name: "Meera Nair",
    email: "meera@studio.io",
    result: "success",
    rowClass: "stp-row-3",
  },
];

/**
 * A tiny looping demo of the anti-spam scoring pipeline: each submission
 * scans, then resolves to spam or a clean contact. Purely decorative CSS
 * animation (see .spam-scan-demo in index.css); prefers-reduced-motion
 * shows the resolved (post-scan) frame instead of looping.
 */
export default function SpamScanAnimation() {
  return (
    <div className="spam-scan-demo" aria-hidden="true">
      <div className="stp-header">
        <span className="stp-col-name">Name</span>
        <span className="stp-col-email">Email</span>
        <span className="stp-col-status">Status</span>
      </div>
      {ROWS.map((row) => (
        <div className={`stp-row ${row.rowClass}`} key={row.email}>
          <span className="stp-col-name">{row.name}</span>
          <span className="stp-col-email">{row.email}</span>
          <span className="stp-col-status stp-status">
            <span className="stp-status-scanning">
              <SyncOutlined spin /> Scanning
            </span>
            <span
              className={`stp-status-result stp-status-${row.result}`}
            >
              {row.result === "success" ? (
                <>
                  <CheckCircleOutlined /> Success
                </>
              ) : (
                <>
                  <CloseCircleOutlined /> Spam
                </>
              )}
            </span>
          </span>
        </div>
      ))}
    </div>
  );
}
